<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">
				<b-field label="景品交換レート"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'prizeExchangeRate') }"
					:message="errors.prizeExchangeRate">
					<div class="horizontal-center">
						<div>景品1ポイントに対して、所有ポイントが</div>
						<b-input type="text" class="prize-exchange-rate ml-5 mr-5" v-model="prizeExchangeRate" />
						<div>ポイント必要</div>
					</div>
				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button type="is-primary" :loading="isLoading" @click="onSubmitClick">更新</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.preview {
	height: auto;
}
.prize-exchange-rate {
	width: 200px;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'
import { Chrome } from 'vue-color'

export default {
	name: 'SiteSetting',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
		Chrome,
	},
	data () {
		return {
			prizeExchangeRate: 1,
			isLoading: false,
			errors: {
				prizeExchangeRate: '',
			},
		}
	},
	computed: {
		titleStack () {
			return [
				'サイト設定',
			]
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"prize_exchange_rate": this.prizeExchangeRate,
			};

			this.$utils.log(data);

			try {
				let ep = 'site-settings';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('データを更新しました');
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'site-settings/screen';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.prizeExchangeRate = res.data.prize_exchange_rate;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
